import React from "react";
import PropTypes from "prop-types";
import "../../assets/style/main.scss";
import MainMenu from "../../components/_default/Menu";



export default function DefaultLayout({ children, active, submenu  }) {
  

  return (
    <div className="app-wrapp">
      <div className="main">
        <header>
          <MainMenu active={active} submenu={submenu} />
        </header>
        {children}
      </div>
    </div>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
  active: PropTypes.string,
  submenu: PropTypes.string,
};
